<ui-modal
  #modal
  [title]="title"
  [size]="size"
  [showCloseButton]="true"
  [closeOnBackdrop]="backdrop !== 'static'"
  (modalClosed)="onCancel()">

  <p class="mb-4">{{ message || 'Are you sure?' }}</p>

  <div modal-footer class="flex gap-2 justify-end">
    <ui-button
      variant="ghost"
      (clicked)="onCancel()">
      {{ cancelText || 'No' }}
    </ui-button>
    <ui-button
      [variant]="confirmVariant"
      (clicked)="onConfirm()">
      {{ confirmText || 'Yes' }}
    </ui-button>
  </div>
</ui-modal>
